var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/clock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75A10.75 10.75 0 1122.75 12 10.759 10.759 0 0112 22.75zm0-20A9.25 9.25 0 1021.25 12 9.261 9.261 0 0012 2.75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M15.71 15.93a.67.67 0 01-.38-.11l-3.1-1.85a2.949 2.949 0 01-1.34-2.36v-4.1a.755.755 0 01.75-.75.755.755 0 01.75.75v4.1a1.478 1.478 0 00.61 1.07l3.1 1.85a.749.749 0 01.26 1.03.77.77 0 01-.65.37z"
  }))));
}
export default SvgVuesaxOutlineClock;